<mat-toolbar class="mat-elevation-z8">
  {{ 'FLIGHT.ARRIVAL.CREATE_NEW_ARRIVAL' | transloco }}
</mat-toolbar>

@if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<mat-dialog-content class="mt-2">
  <form [formGroup]="createArrivalForm">
    <table>
      <tr>
        <td colspan="2">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'FLIGHT.SELECT_STATION' | transloco }}</mat-label>
            <mat-select formControlName="stations" (selectionChange)="stationChange($event)">
              @for (row of stationsVM; track row) {
                <mat-option [value]="row.stationId">
                  <span>
                    Station: {{ row.name }} ({{ row.code }})
                  </span>
                </mat-option>
              }
            </mat-select>
            <mat-icon matSuffix>local_airport</mat-icon>
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'FLIGHT.SELECT_TERMINAL' | transloco }}</mat-label>
            <mat-select formControlName="terminals" (selectionChange)="terminalChange($event)">
              @for (row of terminalsVM; track row) {
                <mat-option [value]="row.terminalId">
                  <span>
                    Station: {{ row.terminalName }} ({{ row.terminalCode }})
                  </span>
                </mat-option>
              }
            </mat-select>
            <mat-icon matSuffix>add_location</mat-icon>
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'FLIGHT.FLIGHT_NUMBER' | transloco }}</mat-label>
            <input matInput formControlName="arrivalCode" placeholder="Flightnummer">
            <mat-icon matSuffix>flight_arrival</mat-icon>
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'FLIGHT.ARRIVAL.PLANNED_ARRIVAL' | transloco }}</mat-label>
            <input matInput formControlName="scheduledArrival" [matDatepicker]="scheduledArrival">
            <mat-datepicker-toggle matSuffix [for]="scheduledArrival"></mat-datepicker-toggle>
            <mat-datepicker #scheduledArrival></mat-datepicker>
          </mat-form-field>
        </td>
        <td>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'FLIGHT.TIME' | transloco }}</mat-label>
            <input matInput type="time" value="{{time}}" formControlName="time">
            <mat-icon matSuffix>schedule</mat-icon>
          </mat-form-field>
        </td>
        <td></td>
      </tr>
    </table>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="isLoading">{{'FORM.TERMSDIALOGCLOSE' | transloco}}</button>
  <button mat-raised-button color="primary" [disabled]="createArrivalForm.invalid || isLoading" (click)="saveArrival()">
    {{'FORM.SAVE' | transloco}}
  </button>
</mat-dialog-actions>
